import { useIsMinTabletSize } from "../../hooks/useMediaQuery";
import {
  styled,
  Pagination as MUIPagination,
  PaginationItem as MUIPaginationItem,
  type PaginationProps,
  type PaginationRenderItemParams,
} from "~/common/mui";
import { C_ON_SURFACE, C_PRIMARY, C_PRIMARY_DISABLED, C_PRIMARY_HOVER, C_SECONDARY_HOVER } from "../icon/Colors";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

export type MUIPaginationProps = PaginationProps;

export const Pagination = (props: PaginationProps) => {
  const isTablet = useIsMinTabletSize();

  const siblingCount = isTablet ? 1 : 0;

  return (
    <MUIPagination
      siblingCount={siblingCount}
      renderItem={defaultRenderItem}
      {...props}
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    />
  );
};

export const defaultRenderItem = (props: PaginationRenderItemParams) => <PaginationItem {...props} />;

export const PaginationItem = styled(MUIPaginationItem)({
  ...getFontStyle(FontSize.BodyMedium),
  lineHeight: "36px", // Match the height for nice alignment
  width: "36px",
  height: "36px",
  margin: 0,
  color: C_ON_SURFACE,
  "&:hover": {
    color: C_SECONDARY_HOVER,
  },
  "& .MuiPaginationItem-icon": {
    fontSize: "24px",
    color: C_PRIMARY,
    "&:hover": {
      color: C_PRIMARY_HOVER,
    },
  },
  "&.Mui-selected": {
    color: C_PRIMARY,
    "&:hover": {
      color: C_PRIMARY_HOVER,
    },
    background: "none",
  },
  "&.Mui-disabled": {
    opacity: 1,
    color: C_PRIMARY_DISABLED,
  },
});
